module.exports = __webpack_public_path__ + "img/KSAT25-45-1000-1-complete.30e22953.png";